// extracted by mini-css-extract-plugin
export var blue = "_1t-g";
export var brand = "_1t-c";
export var darkGrey = "_1t-f";
export var disabled = "_1t-5";
export var disabledSubtle = "_1t-6";
export var error = "_1t-7";
export var green = "_1t-h";
export var grey = "_1t-e";
export var icon = "_1t-0";
export var inherit = "_1t-b";
export var lightGrey = "_1t-d";
export var orange = "_1t-j";
export var pink = "_1t-l";
export var primary = "_1t-1";
export var purple = "_1t-m";
export var quaternary = "_1t-4";
export var red = "_1t-k";
export var secondary = "_1t-2";
export var success = "_1t-a";
export var tertiary = "_1t-3";
export var warning = "_1t-8";
export var warningSecondary = "_1t-9";
export var white = "_1t-n";
export var yellow = "_1t-i";